module.exports = __webpack_public_path__ + "static/media/local_bar.d64dbc0a.svg";